import React from "react";
import { twMerge } from "tailwind-merge";

export const LeftArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.137 4.58a.687.687 0 0 0-.955 0L4.248 8.408a.808.808 0 0 0 0 1.163l3.934 3.83a.687.687 0 0 0 .955 0 .645.645 0 0 0 0-.93L5.562 8.99l3.575-3.48a.645.645 0 0 0 0-.93Z"
        fill="#69687E"
        opacity=".7"
        className={twMerge(className)}
      />
    </svg>
  );
};
